import { render, staticRenderFns } from "./JsonToPptPage.vue?vue&type=template&id=a153cfac"
import script from "./JsonToPptPage.vue?vue&type=script&lang=ts"
export * from "./JsonToPptPage.vue?vue&type=script&lang=ts"
import style0 from "./JsonToPptPage.vue?vue&type=style&index=0&id=a153cfac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports